<div class="actions" [class.no-secondary-actions]="!showSecondaryActions">
  <div class="secondary-actions" *ngIf="showSecondaryActions">
    <button
      type="button"
      class="secondary-action"
      mat-button
      [disabled]="reviewAndSearchDisabled"
      (click)="submitReviewAndSearch()">
      {{ reviewAndSearchLabel }}
    </button>
    <button
      type="button"
      class="secondary-action"
      mat-button
      [disabled]="refineDisabled"
      (click)="submitRefine()">
      {{ refineLabel }}
    </button>
  </div>

  <div class="primary-actions">
    <button
      *ngIf="showBackAction"
      type="button"
      class="back-action small"
      mat-button
      (click)="submitBack()">
      {{ backLabel }}
    </button>
    <button
      *ngIf="showContinueAction"
      type="button"
      class="continue-action small"
      mat-raised-button
      [disabled]="continueDisabled"
      (click)="submitContinue()">
      {{ continueLabel }}
    </button>
  </div>
</div>
